export const FETCH_TOTAL_GREEN_FACTOR_REQUEST =
  '[TotalGreenFactorToday] FETCH_TOTAL_GREEN_FACTOR_REQUEST';
export const FETCH_TOTAL_GREEN_FACTOR_SUCCESS =
  '[TotalGreenFactorToday] FETCH_TOTAL_GREEN_FACTOR_SUCCESS';
export const FETCH_TOTAL_GREEN_FACTOR_FAILURE =
  '[TotalGreenFactorToday] FETCH_TOTAL_GREEN_FACTOR_FAILURE';
